
      <span class="k-progress" [style.width]="progressComplete + '%'" [@progressState]="showProgress"></span>
      <span *ngIf="!filesHaveErrors" class="k-multiple-files-group-wrapper">
        <span class="k-file-group k-icon k-i-copy"></span>
        <span class="k-file-state"></span>
      </span>
      <span *ngIf="filesHaveErrors" class="k-file-invalid-group-wrapper">
        <span class='k-file-group k-icon k-i-files-error'></span>
        <span class="k-file-state"></span>
      </span>
      <span class="k-file-name-size-wrapper">
        <span *ngFor="let file of files"
          [title]="file.name"
          [ngClass]="setFileNameClasses(file)"
        >
          {{file.name}}
        </span>
        <span *ngIf="!filesHaveErrors"
              class="k-file-information">Total: {{ files.length }} files, {{ getTotalFilesSizeMessage(files) }}</span>
        <span *ngIf="filesHaveErrors" class="k-file-validation-message">{{ getInvalidFilesMessage() }}</span>
      </span>
      <kendo-upload-file-list-item-action-button
        [file]='files[0]'
        [disabled]='disabled'
        [progress]='progressComplete'>
      </kendo-upload-file-list-item-action-button>
    